// import React, { useState, useEffect, useRef } from "react";
// import "../imageScrollSection/imageScroll.scss";
// import { headingimg, sliderBannerImg, yellowStar } from "..";
// import Lightbox from "react-image-lightbox";
// import "react-image-lightbox/style.css";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);
// const ImageScroll = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [photoIndex, setPhotoIndex] = useState(0);
//   const imgRef = useRef(null);

//   useEffect(() => {
//     if (imgRef.current) {
//       gsap.to(imgRef.current, {
//         rotationY: 180,
//         ease: "none",
//         scrollTrigger: {
//           trigger: imgRef.current,
//           start: "top bottom",
//           end: "bottom top+=200",
//           scrub: true,
//         },
//       });
//     }
//   }, []);

//   //   const images = [sliderBannerImg];
//   const images = Array(16).fill(sliderBannerImg);

//   return (
//     <div id="projects" className="background-img">
//       <div className="topright-text-wrap">
//         <img src={yellowStar} alt="starImg" className="starImage" />
//         <h1>Works</h1>
//       </div>

//       <div className="banner-slider">
//         <section>
//           <article>
//             <div>
//               <ul>
//                 {/* <li><img src={sliderBannerImg} alt="sliderBannerImg"/></li> */}
//                 {/* <li><img src={sliderBannerImg} alt="Image 1" onClick={() => { setIsOpen(true); setPhotoIndex(0); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 2" onClick={() => { setIsOpen(true); setPhotoIndex(1); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 3" onClick={() => { setIsOpen(true); setPhotoIndex(2); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 4" onClick={() => { setIsOpen(true); setPhotoIndex(3); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 5" onClick={() => { setIsOpen(true); setPhotoIndex(4); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 6" onClick={() => { setIsOpen(true); setPhotoIndex(5); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 7" onClick={() => { setIsOpen(true); setPhotoIndex(6); }} /></li>
// <li><img src={sliderBannerImg} alt="Image 8" onClick={() => { setIsOpen(true); setPhotoIndex(7); }} /></li>
// <li><img src={sliderBannerImg} alt="Image 9" onClick={() => { setIsOpen(true); setPhotoIndex(8); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 10" onClick={() => { setIsOpen(true); setPhotoIndex(9); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 11" onClick={() => { setIsOpen(true); setPhotoIndex(10); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 12" onClick={() => { setIsOpen(true); setPhotoIndex(11); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 13" onClick={() => { setIsOpen(true); setPhotoIndex(12); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 14" onClick={() => { setIsOpen(true); setPhotoIndex(13); }} /></li>
//   <li><img src={sliderBannerImg} alt="Image 15" onClick={() => { setIsOpen(true); setPhotoIndex(14); }} /></li>
// <li><img src={sliderBannerImg} alt="Image 16" onClick={() => { setIsOpen(true); setPhotoIndex(15); }} /></li> */}
//                 {images.map((img, index) => (
//                   <li key={index}>
//                     <img
//                       src={img}
//                       alt={`Image ${index}`}
//                       loading="lazy"
//                       onClick={() => {
//                         setIsOpen(true);
//                         setPhotoIndex(index);
//                       }}
//                     />
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </article>
//         </section>

//         <section>
//           <article>
//             <div>
//               <ul>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 1"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(0);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 2"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(1);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 3"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(2);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 4"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(3);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 5"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(4);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 6"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(5);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 7"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(6);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 8"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(7);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 9"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(8);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 10"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(9);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 11"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(10);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 12"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(11);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 13"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(12);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 14"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(13);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 15"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(14);
//                     }}
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={sliderBannerImg}
//                     alt="Image 16"
//                     onClick={() => {
//                       setIsOpen(true);
//                       setPhotoIndex(15);
//                     }}
//                   />
//                 </li>
//               </ul>
//             </div>
//           </article>
//         </section>
//       </div>

//       <div className="bottomleft-text-wrap">
//         <div className="bottom-left-text">
//           <p>
//             Browse through our success stories and case studies to see how our team consistently delivers solutions that drive growth and build long-term value.
//           </p>
//         </div>
//         <div className="bottom-left-text-img">
//           {/* <img
//             src={headingimg}
//             alt="heading-Img"
//             ref={imgRef}
//             style={{ willChange: "transform", width: "150px" }}
//           /> */}
//         </div>
//       </div>

//       {isOpen && (
//         <Lightbox
//           mainSrc={images[photoIndex]}
//           nextSrc={images[(photoIndex + 1) % images.length]}
//           prevSrc={images[(photoIndex + images.length - 1) % images.length]}
//           onCloseRequest={() => setIsOpen(false)}
//           onMovePrevRequest={() =>
//             setPhotoIndex((photoIndex + images.length - 1) % images.length)
//           }
//           onMoveNextRequest={() =>
//             setPhotoIndex((photoIndex + 1) % images.length)
//           }
//         />
//       )}
//     </div>
//   );
// };

// export default ImageScroll;

// import React, { useState } from "react";
// import "./imageScroll.scss";
// import {
//   Image1,
//   Image2,
//   Image3,
//   Image4,
//   Image5,
//   Image6,
//   Image7,
//   Image8,
//   SampleVideo,
// } from "..";

// const initialMedia = [
//   { type: "image", src: Image1 },
//   { type: "image", src: Image2 },
//   { type: "image", src: Image3 },
//   { type: "image", src: Image4 },
//   { type: "image", src: Image5 },
//   { type: "image", src: Image6 },
//   { type: "image", src: Image7 },
//   { type: "video", src: SampleVideo },
//   { type: "image", src: Image8 },
// ];

// const ImageScroll = () => {
//   const [mediaItems, setMediaItems] = useState(initialMedia);
//   const [lightboxSrc, setLightboxSrc] = useState(null);

//   const handleHover = (index) => {
//     if (index === 4) return;
//     const newItems = [...mediaItems];
//     const temp = newItems[4];
//     newItems[4] = newItems[index];
//     newItems[index] = temp;
//     setMediaItems(newItems);
//   };

//   return (
//     <div className="image-scroll-container">
//       <div className="grid">
//         {mediaItems.map((item, index) => (
//           <div
//             key={index}
//             className="grid-item"
//             onMouseEnter={() => handleHover(index)}
//             onClick={() => setLightboxSrc(item.src)}
//           >
//             {item.type === "image" ? (
//               <img src={item.src} alt={`media-${index}`} />
//             ) : (
//               <video src={item.src} muted loop autoPlay />
//             )}
//           </div>
//         ))}
//       </div>

//       {lightboxSrc && (
//         <div className="lightbox" onClick={() => setLightboxSrc(null)}>
//           {typeof lightboxSrc === "string" && lightboxSrc.includes(".mp4") ? (
//             <video src={lightboxSrc} controls autoPlay />
//           ) : (
//             <img src={lightboxSrc} alt="lightbox" />
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageScroll;

// import React, { useState } from "react";
// import { Fancybox as NativeFancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox/fancybox.css";
// import "../imageScrollSection/imageScroll.scss";

// import {
//   Image1,
//   Image2,
//   Image3,
//   Image4,
//   Image5,
//   Image6,
//   Image7,
//   Image8,
//   SampleVideo,
// } from "..";

// const Fancybox = ({ children }) => {
//   React.useEffect(() => {
//     NativeFancybox.bind("[data-fancybox]");
//     return () => NativeFancybox.destroy();
//   }, []);
//   return <>{children}</>;
// };

// const initialMedia = [
//   { type: "image", src: Image1 },
//   { type: "image", src: Image2 },
//   { type: "image", src: Image3 },
//   { type: "image", src: Image4 },
//   { type: "image", src: Image5 },
//   { type: "image", src: Image6 },
//   { type: "image", src: Image7 },
//   { type: "video", src: SampleVideo },
//   { type: "image", src: Image8 },
// ];

// const ImageScroll = () => {
//   const [mediaItems, setMediaItems] = useState(initialMedia);
//   const [hoverDirection, setHoverDirection] = useState(null);

//   const handleHover = (index) => {
//     if (index === 4) return;

//     // Determine direction relative to center (index 4)
//     const dx = (index % 3) - 1; // col offset
//     const dy = Math.floor(index / 3) - 1; // row offset

//     const direction =
//       dx === 0 && dy === -1
//         ? "top"
//         : dx === 1 && dy === -1
//         ? "top-right"
//         : dx === 1 && dy === 0
//         ? "right"
//         : dx === 1 && dy === 1
//         ? "bottom-right"
//         : dx === 0 && dy === 1
//         ? "bottom"
//         : dx === -1 && dy === 1
//         ? "bottom-left"
//         : dx === -1 && dy === 0
//         ? "left"
//         : dx === -1 && dy === -1
//         ? "top-left"
//         : null;

//     setHoverDirection(direction);

//     if (index === 4) return;
//     const newItems = [...mediaItems];
//     [newItems[4], newItems[index]] = [newItems[index], newItems[4]];
//     setMediaItems(newItems);
//   };

//   return (
//     <div id="projects" className="image-scroll-container">
//       <Fancybox>
//         <div className="grid">
//           {mediaItems.map((item, index) => {
//             const isCenter = index === 4; // only center media gets Fancybox

//             const mediaContent =
//               item.type === "image" ? (
//                 <img src={item.src} alt={`media-${index}`} />
//               ) : (
//                 <video src={item.src} muted autoPlay loop />
//               );

//             return (
//               <div
//                 key={index}
//                 className={`grid-item ${
//                   isCenter ? `active from-${hoverDirection}` : ""
//                 }`}
//                 onMouseEnter={() => handleHover(index)}
//               >
//                 {isCenter ? (
//                   <a
//                     data-fancybox="gallery"
//                     href={item.src}
//                     data-caption={`Media ${index + 1}`}
//                   >
//                     {mediaContent}
//                   </a>
//                 ) : (
//                   mediaContent // others just render as static content
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </Fancybox>
//     </div>
//   );
// };

// export default ImageScroll;

import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "../imageScrollSection/imageScroll.scss";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import {
  Video1,
  Video2,
  Video3,
  Video4,
  Video5,
  Video6,
  Video7,
  Video8,
  Video9,
} from "..";

// const initialMedia = [
//   { type: "video", src: Video1 },
//   { type: "video", src: Video2 },
//   { type: "video", src: Video3 },
//   { type: "video", src: Video4 },
//   { type: "video", src: Video5 },
//   { type: "video", src: Video6 },
//   { type: "video", src: Video7 },
//   { type: "video", src: Video8 },
//   { type: "video", src: Video9 },
// ];

// gsap.registerPlugin(ScrollTrigger);

// const ImageScroll = () => {
//   const [mediaItems, setMediaItems] = useState(initialMedia);
//   const [hoverDirection, setHoverDirection] = useState(null);
//   const timeoutRef = useRef(null);
//   const videoRefs = useRef([]);
//   const gridRefs = useRef([]);

//   useEffect(() => {
//     NativeFancybox.bind("[data-fancybox]");
//     return () => {
//       NativeFancybox.destroy();
//       clearTimeout(timeoutRef.current);
//     };
//   }, [mediaItems]);

//   const playOnlyCenterVideo = () => {
//     videoRefs.current.forEach((video, i) => {
//       if (video) {
//         if (i === 4) {
//           video.play().catch(() => {});
//         } else {
//           video.pause();
//           video.currentTime = 0;
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     playOnlyCenterVideo();
//   }, []);

//   const handleHover = (index) => {
//     if (index === 4) return;

//     const dx = (index % 3) - 1;
//     const dy = Math.floor(index / 3) - 1;

//     const direction =
//       dx === 0 && dy === -1
//         ? "top"
//         : dx === 1 && dy === -1
//         ? "top-right"
//         : dx === 1 && dy === 0
//         ? "right"
//         : dx === 1 && dy === 1
//         ? "bottom-right"
//         : dx === 0 && dy === 1
//         ? "bottom"
//         : dx === -1 && dy === 1
//         ? "bottom-left"
//         : dx === -1 && dy === 0
//         ? "left"
//         : dx === -1 && dy === -1
//         ? "top-left"
//         : null;

//     setHoverDirection(direction);

//     // Add short delay before swapping
//     clearTimeout(timeoutRef.current);
//     timeoutRef.current = setTimeout(() => {
//       const newItems = [...mediaItems];
//       [newItems[4], newItems[index]] = [newItems[index], newItems[4]];
//       setMediaItems(newItems);
//       setTimeout(() => {
//         playOnlyCenterVideo();
//       }, 100);
//     }, 200); // 200ms delay
//   };

//   return (
//     <div id="projects" className="image-scroll-container">
//       <div className="heading-content">
//         <h6>Projects Which We Worked
//           {/* <img src={starImg} alt=""/> */}
//         </h6>
//         <p>
//           Browse through our success stories and case studies to see how our
//           team consistently delivers solutions that drive growth and build
//           long-term value.
//         </p>
//       </div>

//       <div className="grid">
//         {mediaItems.map((item, index) => {
//           const isCenter = index === 4;

//           const mediaContent =
//             item.type === "image" ? (
//               <img src={item.src} alt={`media-${index}`} />
//             ) : (
//               <video
//                 ref={(el) => (videoRefs.current[index] = el)}
//                 src={item.src}
//                 muted
//                 loop
//                 playsInline
//                 style={{ pointerEvents: "none" }}
//               />
//             );

//           return (
//             <div
//               key={index}
//               className={`grid-item ${
//                 isCenter ? `active from-${hoverDirection}` : ""
//               }`}
//               onMouseEnter={() => handleHover(index)}
//               onMouseLeave={() => clearTimeout(timeoutRef.current)}
//             >
//               {isCenter ? (
//                 <a
//                   data-fancybox="gallery"
//                   href={item.src}
//                   data-caption={`Media ${index + 1}`}
//                 >
//                   {mediaContent}
//                 </a>
//               ) : (
//                 mediaContent
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default ImageScroll;

gsap.registerPlugin(ScrollTrigger);

const initialMedia = [
  { type: "video", src: Video1 },
  { type: "video", src: Video2 },
  { type: "video", src: Video3 },
  { type: "video", src: Video4 },
  { type: "video", src: Video5 },
  { type: "video", src: Video6 },
  { type: "video", src: Video7 },
  { type: "video", src: Video8 },
  { type: "video", src: Video9 },
];

const ImageScroll = () => {
  const [mediaItems, setMediaItems] = useState(initialMedia);
  const [hoverDirection, setHoverDirection] = useState(null);
  const timeoutRef = useRef(null);
  const videoRefs = useRef([]);
  const gridRefs = useRef([]);

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox]");
    return () => {
      NativeFancybox.destroy();
      clearTimeout(timeoutRef.current);
    };
  }, [mediaItems]);

  const playOnlyCenterVideo = () => {
    videoRefs.current.forEach((video, i) => {
      if (video) {
        if (i === 4) {
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  };

  useEffect(() => {
    playOnlyCenterVideo();
  }, []);

  const handleHover = (index) => {
    if (index === 4) return;

    const dx = (index % 3) - 1;
    const dy = Math.floor(index / 3) - 1;

    const direction =
      dx === 0 && dy === -1
        ? "top"
        : dx === 1 && dy === -1
        ? "top-right"
        : dx === 1 && dy === 0
        ? "right"
        : dx === 1 && dy === 1
        ? "bottom-right"
        : dx === 0 && dy === 1
        ? "bottom"
        : dx === -1 && dy === 1
        ? "bottom-left"
        : dx === -1 && dy === 0
        ? "left"
        : dx === -1 && dy === -1
        ? "top-left"
        : null;

    setHoverDirection(direction);

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const newItems = [...mediaItems];
      [newItems[4], newItems[index]] = [newItems[index], newItems[4]];
      setMediaItems(newItems);
      setTimeout(() => {
        playOnlyCenterVideo();
      }, 100);
    }, 200);
  };

  // 🔥 Add GSAP Animation
  useLayoutEffect(() => {
    const gridItems = gridRefs.current;

    const directions = [
      "top-left", "top", "top-right",
      "left",     "center", "right",
      "bottom-left", "bottom", "bottom-right"
    ];

    const animations = gridItems.map((el, index) => {
      if (!el) return null;

      const direction = directions[index];
      let x = 0, y = 0;

      switch (direction) {
        case "top-left": x = -100; y = -100; break;
        case "top": y = -100; break;
        case "top-right": x = 100; y = -100; break;
        case "left": x = -100; break;
        case "right": x = 100; break;
        case "bottom-left": x = -100; y = 100; break;
        case "bottom": y = 100; break;
        case "bottom-right": x = 100; y = 100; break;
        default: 
        return null;
      }

      return gsap.fromTo(
        el,
        { opacity: 0, x, y },
        {
          opacity: 1,
          x: 0,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          delay: 0.05 * index,
          scrollTrigger: {
            trigger: "#projects",
            start: "top 80%",
            toggleActions: "restart none none none",
          },
        }
      );
    });

    return () => {
      animations.forEach((anim) => anim?.kill?.());
    };
  }, []);

  return (
    <div id="projects" className="image-scroll-container">
      <div className="heading">
        <p>Projects Which We Worked</p>
        <p>
          Browse through our success stories and case studies to see how our
          team consistently delivers solutions that drive growth and build
          long-term value.
        </p>
      </div>

      <div className="grid">
        {mediaItems.map((item, index) => {
          const isCenter = index === 4;

          const mediaContent =
            item.type === "image" ? (
              <img src={item.src} alt={`media-${index}`} />
            ) : (
              <video
                ref={(el) => (videoRefs.current[index] = el)}
                src={item.src}
                muted
                loop
                playsInline
                preload="auto"
                style={{ pointerEvents: "none" }}
              />
            );

          return (
            <div
              key={index}
              ref={(el) => (gridRefs.current[index] = el)}
              className={`grid-item ${
                isCenter ? `active from-${hoverDirection}` : ""
              }`}
              onMouseEnter={() => handleHover(index)}
              onMouseLeave={() => clearTimeout(timeoutRef.current)}
            >
              {isCenter ? (
                <a
                  data-fancybox="gallery"
                  href={item.src}
                  data-caption={`Media ${index + 1}`}
                >
                  {mediaContent}
                </a>
              ) : (
                mediaContent
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageScroll;
